import { CreditorDetailsHttpService } from '../services/creditor-details-http.service';
import { ApplicationState } from '@feature/store/application-store';
import { Store, select, Action } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as creditorDetailsSelectors from '../selectors/creditor-details.selector';
import { Field } from '@common/models/field-definition';
import { Details } from '@details/Interfaces/details';
import { SaveDetailsWidgetConfigurationRequest } from '@common/models/save-creditor-details-widget-configuration-request';

@Injectable({
  providedIn: 'root'
})
export class CreditorDetailsService {

  constructor(
    private readonly detailsHttpService: CreditorDetailsHttpService,
    private readonly store: Store<ApplicationState>,
  ) { }

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  isLoading(widgetId: number): Observable<boolean> {
    return this.store.pipe(select(creditorDetailsSelectors.isLoading(widgetId)));
  }

  getDetails(widgetId: number): Observable<Details> {
    return this.store.pipe(select(creditorDetailsSelectors.getCreditorDetails(widgetId)));
  }

  getFields(widgetConfigId: number): Observable<Field[]> {
    return this.detailsHttpService.getFields(widgetConfigId);
  }

  createCopyOfConfiguration(saveRequest: SaveDetailsWidgetConfigurationRequest): Observable<boolean> {
    return this.detailsHttpService.createCopyOfConfiguration(saveRequest);
  }

  saveConfiguration(saveRequest: SaveDetailsWidgetConfigurationRequest): Observable<boolean> {
    return this.detailsHttpService.saveConfiguration(saveRequest);
  }
}
